import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ModalService } from '@app/core/modal.service';
import { ModalPublicProperties, ModalResult, FoldersModalComponent as ModalComponent } from './folders-modal.component';

@Injectable({ providedIn: 'root' })
export class FoldersModalService {
  constructor(private modalService: ModalService) {}

  open(properties?: ModalPublicProperties, options?: NgbModalOptions) {
    return this.modalService.open<ModalResult>(ModalComponent, properties, options);
  }
}
